import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Medicine from "./pages/medicine/Medicine";
import NewMedicine from "./pages/medicine/NewMedicine";
import EditMedicine from "./pages/medicine/EditMedicine";
import Supplier from "./pages/supplier/Supplier";
import NewSupplier from "./pages/supplier/NewSupplier";
import EditSupplier from "./pages/supplier/EditSupplier";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import EditPurchase from "./pages/purchase/EditPurchase";
import NewPurchase from "./pages/purchase/NewPurchase";
import Purchase from "./pages/purchase/Purchase";
import Stock from "./pages/stock/Stock";
import FIFOStockViewer from "./pages/stock/FIFOStockViewer";
import NewOpeningStock from "./pages/openingStock/NewOpeningStock";
import PurchaseReturn from "./pages/purchaseReturn/PurchaseReturn";
import NewPurchaseReturn from "./pages/purchaseReturn/NewPurchaseReturn";
import UpdateReturnStatus from "./pages/purchaseReturn/UpdateReternStatus";
import Invoice from "./pages/invoice/Invoice";
import NewInvoice from "./pages/invoice/NewInvoice";
import EditInvoice from "./pages/invoice/EditInvoice";
import ViewInvoice from "./pages/invoice/ViewInvoice";
import NewSalesReturn from "./pages/salesReturns/NewSalesReturn";
import SalesReturnDetails from "./pages/salesReturns/SalesReturnDetails";
import UpdateSalesReturnStatus from "./pages/salesReturns/UpdateSalesReturnStatus";
import SalesReturnsList from "./pages/salesReturns/SalesReturnsList";
import KitMaster from "./pages/master/KitMaster";
import ScrollToTop from "./components/ScrollToTop";
import DebitInvoice from "./pages/invoice/DebitInvoice";
import MonthlyReport from "./pages/reports/MonthlyReport";
import MedicineWiseProfitReport from "./pages/reports/MedicineWiseProfitReport";

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/medicine" element={<Medicine />} />
          <Route path="/new-medicine" element={<NewMedicine />} />
          <Route path="/edit-medicine/:id" element={<EditMedicine />} />

          <Route path="/supplier" element={<Supplier />} />
          <Route path="/new-supplier" element={<NewSupplier />} />
          <Route path="/edit-supplier/:id" element={<EditSupplier />} />

          <Route path="/purchase" element={<Purchase />} />
          <Route path="/new-purchase" element={<NewPurchase />} />
          <Route path="/edit-purchase/:id" element={<EditPurchase />} />

          <Route path="/purchase-return" element={<PurchaseReturn />} />
          <Route path="/new-purchase-return" element={<NewPurchaseReturn />} />
          <Route path="/purchase-returns/:id/status" element={<UpdateReturnStatus />} />

          <Route path="/invoice" element={<Invoice />} />
          <Route path="/new-invoice" element={<NewInvoice />} />
          <Route path="/debit-invoice" element={<DebitInvoice />} />
          <Route path="/edit-invoice/:invoiceId" element={<EditInvoice />} />
          <Route path="/view-invoice/:invoiceId" element={<ViewInvoice />} />

          <Route path="/sales-returns/:id" element={<SalesReturnDetails />} />
          <Route path="/new-sales-return" element={<NewSalesReturn />} />
          <Route path="/sales-return-list" element={<SalesReturnsList />} />
          <Route path="/sales-returns/:id/status" element={<UpdateSalesReturnStatus />} />


          {/*<Route path="/invoice-returns" element={<InvoiceReturnList />} />
          <Route path="/new-invoice-return" element={<NewInvoiceReturn />} />
          <Route path="/invoice-returns/:id" element={<InvoiceReturnDetails />} />
          <Route path="/update-invoice-return/:id/status" element={<UpdateInvoiceReturn />} /> */}

          <Route path="/stock" element={<Stock />} />
          <Route path="/fifo-stock" element={<FIFOStockViewer />} />
          <Route path="/opening-stock" element={<NewOpeningStock />} />

          <Route path="/monthly-report" element={<MonthlyReport />} />
          <Route path="/medicine-profit-report" element={<MedicineWiseProfitReport />} />
          <Route path="/kit" element={<KitMaster />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
